"use client";

import { And, Ella, Il2 } from "@ellaandil/ui";
import { useEffect, useRef, useState } from "react";

export const FooterMobileLogo = () => {
	const containerRef = useRef<HTMLDivElement>(null);
	const logoRef = useRef<HTMLDivElement>(null);
	const [scale, setScale] = useState(1);

	useEffect(() => {
		const updateScale = () => {
			if (!containerRef.current || !logoRef.current) return;
			const containerWidth = containerRef.current.offsetWidth;
			const logoWidth = logoRef.current.offsetWidth;
			if (logoWidth > 0) {
				setScale(containerWidth / logoWidth);
			}
		};

		updateScale();
		const observer = new ResizeObserver(updateScale);
		if (containerRef.current) observer.observe(containerRef.current);
		return () => observer.disconnect();
	}, []);

	return (
		<section
			ref={containerRef}
			className="mx-grid-section-horizontal-margin-page-base h-17.5 md:h-34 lg:hidden overflow-hidden"
		>
			<div
				ref={logoRef}
				className="flex h-full w-fit origin-left"
				style={{ transform: `scaleX(${scale})` }}
			>
				<Ella className="h-full w-auto" />
				<And className="h-full w-auto" />
				<Il2 className="h-full w-auto" />
			</div>
		</section>
	);
};
